import { AxiosInstance } from "axios";
import { ISpecialProjectCommissionRange } from '../interfaces/ISpecialProjectCommissionRange';
import { ApiService } from "../models/Api.model";

enum SpecialProjectCommissionServiceEnum {
  verifyHasCommission = "/verify/",
  getCommissionParameters = "/range-calculated/"
}

export default class SpecialProjectCommissionService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/special-project/commission");
  }
  public verifyHasCommission = async (specialProjectId: number): Promise<boolean> => await this.GET(SpecialProjectCommissionServiceEnum.verifyHasCommission + specialProjectId);
  public getRangeCalculated = async(tradeId: number): Promise<ISpecialProjectCommissionRange> => await this.GET(SpecialProjectCommissionServiceEnum.getCommissionParameters + tradeId);
}



// WEBPACK FOOTER //
// ./src/services/api/SpecialProjectCommission.service.ts